<template>
	<div v-if="iconGridList.length" class="base-core-entry">
		<div
			v-for="(item, index) in iconGridList"
			:key="index"
			class="base-core-item base-core-item--normal"
			@click="handleGridModule(item)"
		>
			<VanImage :src="item.icon" fit="cover" class="base-core-icon" />
			<div class="base-core-label text-overflow">
				{{ item.label }}
			</div>
		</div>
	</div>
</template>

<script setup>
import { watch } from 'vue';
import { Image as VanImage } from 'vant';
import { useIconGrid } from './useIconGrid';

const { iconGridList, getIrCoreConfig, generateGridModules, handleGridModule } = useIconGrid();
watch(
	() => getIrCoreConfig.value,
	() => {
		generateGridModules();
	},
	{ immediate: true, deep: true }
);
</script>

<style lang="less" scoped>
.base-core-entry {
	position: relative;
	margin-top: 0.18rem;
	padding: 0.14rem 0.17rem;
	border-radius: 0.04rem;
	background: #fff;

	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;

	.base-core-item {
		&--normal {
			width: calc((100% - (calc(0.4rem * 3))) / 4);
			margin-right: 0.4rem;
			margin-top: 0.16rem;
			text-align: center;

			&:nth-child(4n) {
				margin-right: 0;
			}
			&:nth-child(-n + 4) {
				margin-top: 0;
			}
			.base-core-icon {
				margin: 0 auto;
				width: 0.4rem;
				height: 0.4rem;
			}
			.base-core-label {
				margin-top: 0.04rem;
				color: #333;
				font-family: 'PingFang SC';
				font-size: 0.12rem;
				font-style: normal;
				font-weight: 400;
				line-height: 0.16rem; /* 133.333% */
			}
		}
	}
}
</style>
